import React, {FC} from 'react';
import {FieldHookConfig, useField} from 'formik';
import {useToggle} from 'hooks/useToggle';

import * as styles from './styles.module.scss';

type InputFieldProps = FieldHookConfig<string> & {
	label: string
	checkbox?: {
		default?: boolean
		text: string
		inputProps: () => React.InputHTMLAttributes<HTMLInputElement>,
	}
}

export const InputField: FC<InputFieldProps> = ({label, checkbox, ...props}) => {
	const [field, meta] = useField(props);
	const {open: checked, toggle} = useToggle(Boolean(checkbox?.default));

	const inputProps = {
		...field,
		...((checkbox && checked) ? checkbox.inputProps() : {}),
	};

	return (
		<div className={styles.wrapper}>
			<label htmlFor={props.name} className={styles.label}>
				{label}
			</label>
			<input className={styles.input}
				placeholder={props.placeholder}
				type={props.type}
				{...inputProps}
			/>
			{checkbox && (
				<div className={styles.checkbox}>
					<input name='checkbox' type='checkbox' onClick={toggle} />
					<label htmlFor='checkbox' className={styles.checkLabel}>
						{checkbox.text}
					</label>
				</div>
			)}
			{meta.touched && meta.error && (
				<div className={styles.error}>
					{meta.error}
				</div>
			)}
		</div>
	);
};
